import Vue from 'vue'

// axios
import axios from 'axios'
const axiosIns = axios.create({
  // You can add your headers here
  // ================================

  //baseURL: 'https://amiable-abyss-ongvuyvttt8s.vapor-farm-d1.com/api/',
  // baseURL: 'http://localhost:85/api/',
  // baseURL: 'http://127.0.0.1:8000/api/',
  baseURL: `${process.env.VUE_APP_BASE_URL}`,
  // timeout: 1000,
  headers: {'Content-Type': 'application/json'}
})

Vue.prototype.$http = axiosIns

export default axiosIns
